import React from "react";
import { Routes, Route } from "react-router-dom";
import VerticalLayout from "../Layouts/index";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => (
  <Routes>
    {publicRoutes.map((route, idx) => (
      <Route path={route.path} element={route.component} key={`pub-${idx}`} />
    ))}
    {authProtectedRoutes.map((route, idx) => (
      <Route
        path={route.path}
        element={
          <AuthProtected>
            <VerticalLayout>{route.component}</VerticalLayout>
          </AuthProtected>
        }
        key={`prot-${idx}`}
      />
    ))}
  </Routes>
);

export default Index;
